import axios from "@/libs/api.request";

export const getActivityList = filterCond => {
  return axios.request({
    url: "activity/getActivityList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};

export const storeActivityData = (data, dataitem) => {
  return axios.request({
    url: "activity/storeActivityData",
    data: { data, dataitem },
    csrf: true,
    method: "post"
  });
};

export const removeActivityData = id => {
  return axios.request({
    url: "activity/removeActivityData",
    data: { id },
    csrf: true,
    method: "post"
  });
};

export const removeActivityDataItem = id => {
  return axios.request({
    url: "activity/removeActivityDataItem",
    data: { id },
    csrf: true,
    method: "post"
  });
};
